/**
 * CommandPaletteTrigger
 *
 * A fake search input displayed on the Start Page that opens the command palette on click.
 * Purely visual — no actual input handling.
 */

import { Search } from 'lucide-react';
import { useShortcutLabel } from '../../keybindings/hooks/useShortcutLabel';
import { useCommandPaletteStore } from '../store/commandPaletteStore';

export function CommandPaletteTrigger() {
  const shortcutLabel = useShortcutLabel('global.commandPalette');
  const open = useCommandPaletteStore((s) => s.open);

  return (
    <button
      type="button"
      onClick={open}
      className="flex w-full items-center gap-2 rounded-md border border-input bg-background px-3 py-2 text-sm text-muted-foreground ring-offset-background hover:bg-accent hover:text-accent-foreground transition-colors cursor-pointer outline-none focus-visible:ring-1 focus-visible:ring-ring/30 focus-visible:ring-offset-1 focus-visible:ring-offset-background"
    >
      <Search className="h-4 w-4 shrink-0" />
      <span className="flex-1 text-left">
        Type a command or search...{shortcutLabel ? ` (${shortcutLabel})` : ''}
      </span>
    </button>
  );
}
